<template>
    <div>
        <div class="detectionForm">
            <!-- 原表单内容不变 -->
            <div style="display: flex;justify-content: space-between;">
                <InputField label="标题" type="text" id="name" inputDivWidth="80%" style="width: 48%"
                            label-width="20%" :modelValue="form.title" placeholder="请输入标题"
                            required @update:modelValue="(value) => handleModelValueUpdate('title', value)"/>
                <DatePickerField
                    label="检测日期"
                    label-width="25%"
                    inputDivWidth="80%"
                    style="width: 48%"
                    required
                    :modelValue="form.detectionDate"
                    placeholder="请输入检测日期"
                    id="detectionDate"
                    name="detectionDate"
                @update:modelValue="(value) => handleModelValueUpdate('detectionDate', value)"
                />
            </div>
            <div style="display: flex;justify-content: space-between;">
                <InputField label="检测人" type="text" id="man" inputDivWidth="80%" style="width: 48%"
                            label-width="20%" :modelValue="form.man" placeholder="请输入检测人"
                            required @update:modelValue="(value) => handleModelValueUpdate('man', value)"/>
                <SelectField label="检测结果" id="result" :modelValue="form.result"
                             :options="typeList" required labelWidth="25%" style="width: 48%"
                             @update:modelValue="(value) => handleModelValueUpdate('result', value)"
                />
            </div>
            <div class="form-quill">
                <label class="form-label">
                    <span style="color: #ff5a5a;">*</span>
                    检测内容
                </label>
                <div class="input-container" style="width:90%;float: right;">
                    <quill-editor v-model="content" ref="myQuillEditor" :options="editorOption"
                                  placeholder="请输入检测内容" :style="container"
                                  @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)">
                    </quill-editor>
                </div>
            </div>
            <div class="form-button">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField text="保存" primary @click="handleSubmit"/>
                    <ButtonExport format="pdf" :isLoading="isLoading" :isSuccess="isSuccess"
                                  @click="handleExport('pdf')">{{isLoading?'导出中……':'导出PDF报告'}}</ButtonExport>
                </a-space>
            </div>
        </div>
        <div id="pdfTemplate" style="display: none; padding: 20px; background: white; color: #333;">
            <h2 style="text-align: center; margin-bottom: 30px; color: #0b4948;">检测报告</h2>
            <div style="margin: 15px 0;">
                <span style="font-weight: bold; display: inline-block; width: 100px;">标题：</span>
                <span>{{ form.title || '无' }}</span>
            </div>
            <div style="margin: 15px 0;">
                <span style="font-weight: bold; display: inline-block; width: 100px;">检测日期：</span>
                <span>{{form.detectionDate ? form.detectionDate : '无'}}</span>
            </div>
            <div style="margin: 15px 0;">
                <span style="font-weight: bold; display: inline-block; width: 100px;">检测人：</span>
                <span>{{ form.man || '无' }}</span>
            </div>
            <div style="margin: 15px 0;">
                <span style="font-weight: bold; display: inline-block; width: 100px;">检测结果：</span>
                <span>{{ form.result || '无' }}</span>
            </div>
            <div style="margin: 20px 0; border-top: 1px solid #eee; padding-top: 20px;">
                <h4 style="margin-bottom: 10px;">检测内容：</h4>
                <div v-html="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import html2pdf from 'html2pdf.js'
export default {
    name: "detectionForm",
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            exportShow:false,
            form:{
                title: '',
                detectionDate: '',
                man: '',
                result: '',
            },
            content: '',
            editorOption: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'font': [] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'align': [] }],
                        ['clean'],
                        ['link', 'image', 'video']
                    ]
                }
            },
            container: {
                height: '40vh',
                style: {
                    fontSize: '16px'
                }
            },
            typeList:[
                {name:'开始',value:'开始'},{name:'异常',value:'异常'}
            ]
        };
    },
    props:{
        detectionForm:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    mounted() {
        this.form = {
            id: this.detectionForm.id || '',
            title: this.detectionForm.title || '',
            detectionDate: this.detectionForm.detectionDate || '',
            man: this.detectionForm.man || '',
            result: this.detectionForm.result || ''
        };
        this.content = this.detectionForm.content || '';
        console.log("this.form::detectionForm::",this.form)
    },
    methods: {
        async handleExport(format) {
            if (format === 'pdf') {
                this.isLoading = true;
                try {
                    await this.exportToPdf();
                    this.isSuccess = true;
                    setTimeout(() => {
                        this.isSuccess = false;
                    }, 1500);
                } catch (error) {
                    console.error('导出PDF失败:', error);
                    this.$message.error('导出PDF失败，请重试');
                } finally {
                    this.isLoading = false;
                }
            }
        },

        exportToPdf() {
            // 创建PDF内容
            const element = this.generatePdfContent();

            // 设置PDF选项
            const opt = {
                margin: 10,
                filename: `${this.form.title || '检测报告'}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait'
                }
            };

            // 生成PDF
            return html2pdf().from(element).set(opt).save();
        },

        generatePdfContent() {
            const content = document.createElement('div');
            content.style.padding = '20px';
            content.style.fontFamily = 'Arial, sans-serif';
            content.style.lineHeight = '1.6';

            // 标题
            const title = document.createElement('h1');
            title.textContent = this.form.title || '检测报告';
            title.style.textAlign = 'center';
            title.style.marginBottom = '30px';
            title.style.color = '#333';
            content.appendChild(title);

            // 基本信息表格
            const table = document.createElement('table');
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
            table.style.marginBottom = '30px';

            const data = [
                ['检测日期', this.form.detectionDate || '未填写'],
                ['检测人', this.form.man || '未填写'],
                ['检测结果', this.form.type || '未填写']
            ];

            data.forEach(row => {
                const tr = document.createElement('tr');
                row.forEach((cell, index) => {
                    const td = document.createElement('td');
                    td.textContent = cell;
                    td.style.padding = '8px 12px';
                    td.style.border = '1px solid #ddd';
                    td.style.backgroundColor = index === 0 ? '#f5f5f5' : '#fff';
                    td.style.fontWeight = index === 0 ? 'bold' : 'normal';
                    tr.appendChild(td);
                });
                table.appendChild(tr);
            });

            content.appendChild(table);

            // 检测内容
            const contentTitle = document.createElement('h2');
            contentTitle.textContent = '检测内容';
            contentTitle.style.marginBottom = '15px';
            contentTitle.style.color = '#333';
            contentTitle.style.borderBottom = '2px solid #333';
            contentTitle.style.paddingBottom = '5px';
            content.appendChild(contentTitle);

            const contentDiv = document.createElement('div');
            contentDiv.innerHTML = this.content || '<p>暂无检测内容</p>';
            contentDiv.style.minHeight = '200px';
            content.appendChild(contentDiv);

            // 页脚
            const footer = document.createElement('div');
            footer.style.marginTop = '50px';
            footer.style.textAlign = 'center';
            footer.style.color = '#666';
            footer.style.fontSize = '12px';
            footer.innerHTML = `生成时间: ${new Date().toLocaleString()}`;
            content.appendChild(footer);

            return content;
        },

        cancel() {
            this.$emit('cancel');
        },

        handleSubmit() {
            this.form.content = this.content;
            this.$emit('handle-submit', this.form);
        },

        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },

        onEditorBlur(editor) {
            console.log('editor blur!', editor);
        },

        onEditorFocus(editor) {
            console.log('editor focus!', editor);
        },

        onEditorReady(editor) {
            console.log('editor ready!', editor);
        }
    }
};
</script>
<style scoped>
.detectionForm {
    color: #94a3b8;
}
.detectionForm > div {
    margin: 1rem 0;
}
.form-quill{
    height: 48vh;
}
.form-button{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .ql-toolbar.ql-snow{
    border: 1px solid #0b4948;
    background: #070f1c;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
::v-deep .ql-container.ql-snow{
    border: 1px solid #0b4948;
    background: #0e1b34;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
::v-deep .ql-snow .ql-picker{
    color: #adadad;
}
::v-deep .ql-snow .ql-fill,::v-deep .ql-snow .ql-stroke.ql-fill{
    fill:#adadad;
}
::v-deep .ql-snow .ql-stroke{
    stroke:#adadad;
}

/* PDF模板样式（仅用于导出，不影响页面显示） */
#pdfTemplate {
    font-size: 14px;
    line-height: 1.6;
}
#pdfTemplate h2 {
    font-size: 20px;
}
#pdfTemplate h4 {
    font-size: 16px;
}
#pdfTemplate img {
    max-width: 100%;
    height: auto;
}
#pdfTemplate pre {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
}
</style>